import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FormSandboxComponent } from './form-sandbox/form-sandbox.component';
import { SandboxComponent } from './sandbox.component';

const routes: Routes = [
  {
    path: '',
    component: SandboxComponent,
    children: [{ path: 'forms', component: FormSandboxComponent }],
  },
  { path: '**', redirectTo: 'forms' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SandboxRoutingModule {}
